import moment from 'moment';
import apiClient from '.';

const generateReports = async (params: any) => {
    try {
        return (
            (
                await apiClient.post('reports/tableau/generate', {
                    data: params,
                })
            )?.data || {}
        );
    } catch (e) {
        return { error: e };
    }
};

const getReportsStatus = async (template: any) => {
    try {
        const { data }: any =
            (await apiClient.get('jobs/status', {
                queryParams: { session_id: template?.sessionId },
            })) || {};
        return {
            ...template,
            ...data,
            lastUpdated: moment().format('lll'),
        };
    } catch (e) {
        return { ...template, status: 'error' };
    }
};

export { generateReports, getReportsStatus };
